const staff = {
    title: 'Ekipa',
}

export default staff
